module.exports = __webpack_public_path__ + "static/media/cert7.de57081d.png";